import React, { useState } from 'react';
import { string, arrayOf, bool, func } from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import { URI } from '@fiverr-private/futile';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_down } from '@fiverr-private/icons';
import { logger } from '@fiverr-private/obs';
import { IDEA_TAGS } from './propTypes';
import { ALLOW_TO_SHOW_ALL_ITEMS_MAX_AMOUNT, LIMITED_ITEMS_BASE_AMOUNT } from './constants';
import './style.scss';

const getTagLink = (type, tag) => {
    if (!type || !tag) {
        logger.error(new Error(`Missing required params for tag pages per type: ${type} and tag: ${tag}`));
    }

    return pathfinder('logo_maker_buyer_ideas_page', {
        type,
        tag,
    });
};

const renderItems = (items, onClick = noop, refCtxId = '') => {
    const handleOnClick = (event, { tagType, tagId }) => {
        event.target.href = new URI(event.target.href).addParams({ ref_ctx_id: refCtxId }).toString();

        onClick({ tagType, tagId });
    };

    return items.map(({ tagName, tagId, tagType }, index) => (
        <a
            key={index}
            className="idea-tag"
            onClick={(event) => handleOnClick(event, { tagType, tagId })}
            href={getTagLink(tagType, tagId)}
        >
            {tagName}
        </a>
    ));
};

const IdeaTags = ({ title, onClick, refCtxId, expandLabel, tags, showAll = false }) => {
    const [expanded, setExpanded] = useState(false);
    const tagsAmount = tags.length;
    if (!tagsAmount) {
        return null;
    }
    if (!showAll) {
        showAll = tagsAmount <= ALLOW_TO_SHOW_ALL_ITEMS_MAX_AMOUNT;
    }
    const items = showAll ? tags : tags.slice(0, LIMITED_ITEMS_BASE_AMOUNT);
    const additialItems = showAll ? [] : tags.slice(LIMITED_ITEMS_BASE_AMOUNT);
    const hasAdditialItems = !!additialItems.length;

    return (
        <div className="idea-tags">
            <div className="max-width-container inner">
                <h2>{title}</h2>
                <div className="idea-tags-wrapper">
                    {renderItems(items, onClick, refCtxId)}
                    {!expanded && hasAdditialItems && (
                        <div
                            className={classnames('idea-tags-more', {
                                expanded,
                            })}
                        >
                            <button type="button" onClick={() => setExpanded(true)}>
                                {expandLabel}
                                <Icon className="idea-tags-icon" size={10} color="blue">
                                    {l_chevron_down}
                                </Icon>
                            </button>
                        </div>
                    )}
                    {hasAdditialItems && renderItems(additialItems, onClick, refCtxId)}
                </div>
            </div>
        </div>
    );
};

IdeaTags.propTypes = {
    title: string,
    showAll: bool,
    refCtxId: string,
    onClick: func,
    expandLabel: string,
    tags: arrayOf(IDEA_TAGS),
};

export default IdeaTags;
